export default "__VITE_ASSET__CcP$6gnL__"